enum ProjectMilestoneStatus {
  Draft = "Draft",
  InApproval = "InApproval",
  Approved = "Approved",
  Rejected = "Rejected",
  Skipped = "Skipped",
  Released = "Released",
  Reenable = "Reenable",
}

export default ProjectMilestoneStatus;
